import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

// servicios
import { NotificacionesService } from '../notificaciones.service';
import { UsuarioService } from './usuario.service';

// interfaces
import { IApiResp } from 'src/app/interfaces/api-resp';
import { IArticulo } from 'src/app/interfaces/articulo';
import { IListaOpciones } from 'src/app/interfaces/lista-opciones';

// librerías y entrono
import { environment } from 'src/environments/environment';



@Injectable({
  providedIn: 'root'
})
export class StockService {

  apiURL: string = environment.apiURL;

  constructor(
    private http: HttpClient,
    private usuarioSrv: UsuarioService,
    private notificacionesSrv: NotificacionesService,
  ) { }

  getLista(_opciones: IListaOpciones = {}) {
    // Devulve la lista filtrada
    const path = `${this.apiURL}/stock/listFiltro`;

    const data = {
      id_almacen: _opciones.id_almacen || null,
      id_cliente: _opciones.id_cliente || null,
      id_articulo: _opciones.id_articulo || null,
      id_ubicacion: _opciones.id_ubicacion || null,
      codUbi: _opciones.codUbi || null,
      ean: _opciones.ean || null,
    };

    return this.http.post<IApiResp>(path, data)
  }

  getListaHistorico(_opciones: any = {}) {
    // Devulve la lista del histórico de Stock filtrada
    const path = `${this.apiURL}/stock/listFiltroHistorico`;
    const data = {
      fechaHistorico: _opciones.fechaHistorico || null,
      id_almacen: _opciones.id_almacen || null,
      id_cliente: _opciones.id_cliente || null
    };

    return this.http.post<IApiResp>(path, data)
  }


  // Datos del stock para un artículo y lote
  stockLote(_datos: {
    "id_articulo": number,
    "lote": string
  }) {
    const path = `${this.apiURL}/stock/stockLote`;
    return this.http.post<IApiResp>(path, _datos)
  }


  // Actualiza fechaCaducidad del stock para registros con un artículo y lote
  UpdateFechaCaducidad(_datos: {
    "id_articulo": number,
    "lote": string,
    "fechaCaducidad": Date
  }) {
    const path = `${this.apiURL}/stock/UpdateFechaCaducidad`;
    return this.http.post<IApiResp>(path, _datos)
  }


  getRec(id: number) {
    const path = `${this.apiURL}/stock/list/${id}`;
    const resp = this.http.get<IApiResp>(path)
    return resp;
  }


  newRec(formData: any) {
    const path = `${this.apiURL}/stock/new`;
    return this.http.post<IApiResp>(path, formData)
  }

  update(articulo: IArticulo) {
    const path = `${this.apiURL}/stock/update/${articulo.id}`;
    return this.http.post<IApiResp>(path, articulo)
  }


  delete(datos: any) {
    const path = `${this.apiURL}/stock/delete`;
    return this.http.post<IApiResp>(path, datos)
  }

  // Pone a 0 una reserva
  deleteReserva(id_stock: number) {
    const path = `${this.apiURL}/stock/deleteReserva/${id_stock}`;
    return this.http.get<IApiResp>(path)
  }
  // Pone a 0 todas las reservas de un cliente
  deleteReservasCliente(id_cliente: number) {
    const path = `${this.apiURL}/stock/deleteReservasCliente/${id_cliente}`
    return this.http.get<IApiResp>(path)
  }

  // Mueve TODO el contenido de una ubicación a otra
  stockMueve(datos: any) {
    const path = `${this.apiURL}/stock/stockMueve`;
    return this.http.post<IApiResp>(path, datos)
  }

  // Mueve n referencias de un artículo a otra ubicación
  stockMueveArticulo(datos: any) {
    const path = `${this.apiURL}/stock/stockMueveArticulo`;
    return this.http.post<IApiResp>(path, datos)
  }


  // Analiza oportunidades de compactación
  getAnalisisCompactacion(_opciones: IListaOpciones = {}) {
    const path = `${this.apiURL}/stock/analisisCompactacion`;
    const data = {
      id_cliente: _opciones.id_cliente || null,
      id_almacen: _opciones.id_almacen || null
    };
    return this.http.post<IApiResp>(path, data)
  }

  // Resumen general de oportunidades de compactación (Totales por severidad)
  getResumenCompactacion(_opciones: IListaOpciones = {}) {
    const path = `${this.apiURL}/stock/resumenCompactacion`;
    const data = {
      id_almacen: _opciones.id_almacen || null,
      id_cliente: _opciones.id_cliente || null,
      id_articulo: _opciones.id_articulo || null,
    };
    return this.http.post<IApiResp>(path, data)
  }

  // Genera el plan de compactación
  generarPlanCompactacion(_datos: {
    "id_almacen": number,
    "id_cliente": number,
    "id_articulo": number,
    "capacidad_historica": number
  }) {
    const path = `${this.apiURL}/stock/generarPlanCompactacion`;
    return this.http.post<IApiResp>(path, _datos)
  }

  ///// AUX ////

  errorAuth() {
    this.usuarioSrv.logOut();
    console.log('error', 'No estás autorizado a hacer esta operación');
  }


}
